var map = {
	"./black/bofangluxiang2.png": "L5sT",
	"./blue/bofangluxiang2.png": "Ilzg",
	"./white/bofangluxiang2.png": "56GG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5Iqu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/bofangluxiang2\.png$
// module id = 5Iqu
// module chunks = 24